<div>
  <div class="avatar-container">
    <label class="button primary block" for="single">
      <div id="image-container" class="image-wrapper">
        @if (!isImageLoaded) {
          <ion-skeleton-text animated></ion-skeleton-text>
        }
        <ion-img
          [src]="charity?.avatarUrl"
          alt="Avatar"
          (ionImgDidLoad)="isImageLoaded = true"
          class="img-avatar {{!isImageLoaded ? 'hidden' : 'fade-in'}}"
        ></ion-img>
      </div>
    </label>

    <input
      style="visibility: hidden; position: absolute"
      type="file"
      id="single"
      accept="image/*"
      (change)="selectImage($event)"
      />
  </div>


  <ion-modal [isOpen]="isModalOpen">
    <ng-template>
      <div class="img-cropper-container">
        <ion-row>
          <ion-col size="2" class="ion-text-center">
            <ion-button id="btn-rotate-hover" fill="clear" (click)="rotate()">
              <ion-icon name="refresh" slot="start"></ion-icon>
            </ion-button>
            <ion-popover trigger="btn-rotate-hover" triggerAction="hover">
              <ng-template>Rotate</ng-template>
            </ion-popover>
          </ion-col>
          <ion-col size="2" class="ion-text-center">
            <ion-button fill="clear" (click)="flipHorizontal()">
              <ion-icon name="code-outline"></ion-icon>
            </ion-button>
          </ion-col>
          <ion-col size="2" class="ion-text-center">
            <ion-button fill="clear" (click)="flipVertical()">
              <ion-icon name="chevron-expand-outline"></ion-icon>
            </ion-button>
          </ion-col>
          <ion-col size="2" class="ion-text-center">
            <ion-button fill="clear" (click)="discardChanges()">
              <ion-icon name="close-circle-outline"></ion-icon>
            </ion-button>
          </ion-col>
          <ion-col size="2" class="ion-text-center">
            <ion-button fill="clear" (click)="cropImage()">
              <ion-icon name="checkmark-circle-outline"></ion-icon>
            </ion-button>
          </ion-col>
        </ion-row>

        <image-cropper
          #cropper
          [imageFile]="imageFile"
          [maintainAspectRatio]="maintainAspectRatio"
          [aspectRatio]="1"
          (imageCropped)="imageCropped($event)"
          (imageLoaded)="imageLoaded()"
          (loadImageFailed)="loadImageFailed()"
          format="jpeg"
          [transform]="transform"
          [autoCrop]="false"
          [resizeToWidth]="512"
          outputType="blob"
        ></image-cropper>
      </div>
    </ng-template>
  </ion-modal>
</div>
